import _ from 'lodash'
import classNames from 'classnames'
import { Image } from 'react-bootstrap'
import React, { useEffect } from 'react'
import Avatar from '@mui/material/Avatar'
import { translate } from 'react-multi-lang'
import { useDispatch, useSelector } from 'react-redux'

import {
  fetchBulkSendUserStart,
  fetchBulkSendUserSuccess,
  toggleBulkSendUserSelected
} from '../../store/actions/ChatAction'
import { SpinnerLoader } from '../../components/Loader/ChatLoader'

import './style.css'
import Location from '../common/Location'
const defaultProfile = 'https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/default/profile_placeholder.jpg'

const ChatUserList = ({ searchQuery }) => {
  const dispatch = useDispatch()
  const bulkSendUsers = useSelector((state) => state.chat.bulkSendUsers)
  const chatFilters = useSelector((state) => state.chat.chatFilters)

  useEffect(() => {
    if (chatFilters.bulkUsersFilter) {
      dispatch(fetchBulkSendUserStart(chatFilters.bulkUsersFilter))
    }
  }, [chatFilters.bulkUsersFilter])

  const isMatch = (data) => {
    if (!searchQuery) return true
    const regex = new RegExp(searchQuery, 'i')
    return regex.test(data.name) || regex.test(data.username)
  }

  const isSelected = (id) => {
    return bulkSendUsers?.selected.includes(id)
  }

  const toggleSelect = (id) => {
    dispatch(toggleBulkSendUserSelected(id))
  }

  const selectAll = () => {
    dispatch(fetchBulkSendUserSuccess(bulkSendUsers.data))
  }

  return (
    <>
      <div className="sendname">
        <label> {bulkSendUsers.selected.length} People Selected </label>
        <div className="viewallbtn">
          <a className="btn btn-link" onClick={() => selectAll()} aria-label='select all'>
            Select All
            <Image src="https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/clarity_sort-by-line.svg" alt='clarity icon'/>
          </a>
        </div>
      </div>
      {bulkSendUsers.data
        .filter((user) => isMatch(user))
        .map((user, index) => (
          <li
            key={`_user_${index}`}
            className={`${isSelected(user.id) ? 'active' : ''}`}
            onClick={() => toggleSelect(user.id)}
          >
            <div className="imgchat">
              <Avatar
                src={user?.picture}
                style={{ width: '72px', height: '72px' }}
                className=" img-fluid"
                alt='avtar'
              >
                <img
                  src={defaultProfile}
                  style={{ width: '72px', height: '72px' }}
                  alt="profile"
                />
              </Avatar>
            </div>
            <div className={classNames('username-text')}>
              <p>{`${user?.name}`}</p>
              <Location
                className="message-user-location"
                fontSize={12}
                city={user.city}
                country={user.country}
              />
            </div>
          </li>
        ))}
      {bulkSendUsers.loading && <SpinnerLoader />}
      {!bulkSendUsers.loading && bulkSendUsers.data?.length === 0 && (
        <h6 className="text-center">No users</h6>
      )}
    </>
  )
}

export default translate(ChatUserList)
